import React, { Component } from 'react';
import Container from '@material-ui/core/Container';
import OrganizationChartPage from '../Directorate/OrganizationChartPage';
import client from '../Contentful_API/api';
import CardMedia from "@material-ui/core/CardMedia";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { SimpleShareButtons } from "react-simple-share";
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import "./styles.css";
import { Link } from 'react-router-dom'
import MinistryLogo from '../Logo/lgfinal.png';

const SocialShare = () => (
    <SimpleShareButtons
        whitelist={["Facebook", "Twitter", "LinkedIn", "Google+"]}
        size="20px"
    />
);

function LinkList(props) {
    const menu = props.menus;
    const fields = menu?.fields || {};
    const imageUrl = fields.mediafile?.fields?.file?.url || fields.image?.fields?.file?.url || '';
    const slug = fields.slug || fields.slugMName || '';
    const title = fields.title || fields.subMName || 'Ministry information';
    const profileLink = slug ? `/pagedetails/${slug}` : '/profile';

    return (
        menu ? (
            <div className="profile-card-wrapper">
                <Link to={profileLink} className="profile-card-link">
                    <Card className="profile-card">
                        {imageUrl && (
                            <CardMedia
                                component="img"
                                className="profile-card-image"
                                src={imageUrl}
                                alt={title}
                                title={title}
                            />
                        )}

                        <CardContent className="profile-card-content">
                            <Typography variant="h6" component="h3" className="profile-card-title">
                                {title}
                            </Typography>
                            <div className="profile-card-socials">
                                <SocialShare />
                            </div>
                        </CardContent>

                        <CardActions className="profile-card-actions">
                            <Button className="profile-card-button" component="span" variant="contained">
                                View profile
                            </Button>
                        </CardActions>
                    </Card>
                </Link>
            </div>
        ) : "Please wait while data is being fetched"
    )
}

function isLeadershipMenu(menu) {
    const fields = menu?.fields || {};
    const title = fields.title || fields.subMName || fields.slug || fields.slugMName || '';
    const normalizedTitle = title.toLowerCase().replace(/[^a-z]/g, '');

    return ['minister', 'ministeroffinance', 'viceminister', 'viceministeroffinance'].includes(normalizedTitle);
}



class Profile extends Component {

    state = {
        menus: [],
        searchString: ''
    }
    constructor() {
        super()
        this.getExecutives()
    }
    getExecutives = () => {
        client.getEntries({
            content_type: 'menus', 'fields.type': 'about',
            order: 'fields.menuorder'
        })
            .then((response) => {
                this.setState({ menus: response.items })
                console.log(this.state.menus)
            })
            .catch((error) => {
                console.log("Error occurred while fetching Entries")
                console.error(error)
            })

    }

    render() {
        const leadershipMenus = this.state.menus.filter(isLeadershipMenu).slice(0, 2);

        return (
            <Container>
                <br />
                {this.state.menus ? (
                    <>
                        <div className="cards profile-leadership">
                            {leadershipMenus[0] && (
                                <div className="card" key={leadershipMenus[0]?.sys?.id || leadershipMenus[0]?.fields?.slug}>
                                    <LinkList menus={leadershipMenus[0]} />
                                </div>
                            )}
                            <div className="profile-government" aria-label="Government of Timor-Leste, IX Constitutional Government">
                                <img src={MinistryLogo} alt="Ministry of Finance emblem" />
                                <p>Government of Timor-Leste</p>
                                <strong>IX Constitutional Government</strong>
                            </div>
                            {leadershipMenus[1] && (
                                <div className="card" key={leadershipMenus[1]?.sys?.id || leadershipMenus[1]?.fields?.slug}>
                                    <LinkList menus={leadershipMenus[1]} />
                                </div>
                            )}
                        </div>
                    </>
                ) : "No Menu found"}

                <OrganizationChartPage embedded />
            </Container>
        )
    }
}

export default Profile;
